import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Button,
  Paper,
  IconButton
} from '@mui/material';
import { ErrorOutline, Refresh, ReportProblem } from '@mui/icons-material';

const ErrorBoundary = ({ children }) => {
  const [error, setError] = useState(null);
  const [errorInfo, setErrorInfo] = useState(null);

  const componentDidCatch = (error, errorInfo) => {
    setError(error);
    setErrorInfo(errorInfo);
    // Log to error tracking service
    console.error('ErrorBoundary caught:', error, errorInfo);
  };

  if (error) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '100vh',
        p: 3,
        bgcolor: 'background.default'
      }}>
        <Paper elevation={3} sx={{ 
          p: 4, 
          maxWidth: 600,
          textAlign: 'center',
          borderLeft: '4px solid',
          borderColor: 'error.main'
        }}>
          <Box sx={{ mb: 3 }}>
            <ErrorOutline sx={{ 
              fontSize: 60, 
              color: 'error.main',
              mb: 1
            }} />
            <Typography variant="h4" gutterBottom>
              Quantum Disruption Detected
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Our systems encountered an anomaly. Don't worry - your data is safe.
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {error.toString()}
            </Typography>
            
            <Button
              variant="contained"
              color="primary"
              startIcon={<Refresh />}
              onClick={() => window.location.reload()}
              sx={{ mr: 2 }}
            >
              Recalibrate
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Return Home
            </Button>
          </Box>
          
          {process.env.NODE_ENV === 'development' && (
            <Box sx={{ 
              mt: 3,
              p: 2,
              bgcolor: 'background.paper',
              borderRadius: 1,
              textAlign: 'left',
              maxHeight: 200,
              overflow: 'auto'
            }}>
              <Typography variant="caption" component="pre">
                {errorInfo.componentStack}
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>
    );
  }

  return children;
};

export default ErrorBoundary;